export const firebaseLists = {
  MYLISTS: 'myLists',
};

export default firebaseLists;
